import type { SVGProps } from 'react'
const SvgSyArrowRightUpSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M20.1 6.3 3.3 23 1 20.7 17.7 4H5.1V.7h18.2v18.2H20V6.3z" />
	</svg>
)
export default SvgSyArrowRightUpSystem
